module.exports = "<ngx-charts-pie-grid\n  [view]=\"view\"\n  [scheme]=\"colorScheme\"\n  [results]=\"single\"\n  [gradient]=\"gradient\"\n  [animations]=\"true\"\n  (select)=\"onSelect($event)\">\n</ngx-charts-pie-grid>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modulos/graficos/pie-grid/pie-grid.component.html
// module id = ./src/app/modulos/graficos/pie-grid/pie-grid.component.html
// module chunks = main